module.exports = __webpack_public_path__ + "static/media/systray_301.079968b0.ico";